import { Box, BoxProps } from '@mui/material';

import { withSxProp } from 'common/utils/props';

interface IProps extends BoxProps {
    outlined?: boolean;
}

export const ProgressBox = ({ outlined, sx, ...other }: IProps) => (
    <Box
        sx={[
            {
                backgroundColor: 'white',
                borderColor: 'divider',
                borderRadius: 1,
                minHeight: 30,
                display: 'flex',
                justifyContent: 'center',
                border: 0,
                py: 0,
                px: 0,
            },
            outlined && {
                border: 1,
                py: 0.5,
                px: 1.5,
            },
            ...withSxProp(sx),
        ]}
        {...other}
    />
);
